module.exports = __webpack_public_path__ + "media/icons/tablica_rejestracyjna-73040c2b.png";